
import React from 'react'
import { Link } from 'react-router-dom'
import { BaseUrl } from '../../helper/BaseUrl';

export default function DynamicService({ data, extraClass = "" }) {
    if (!data) return null;
    return (
        <section className={`healthcare-Premise ${extraClass}`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-12 col-lg-6">
                        <div className="facilities-image">
                            <img src={data?.section6_image ? `${BaseUrl}${data.section6_image}` : undefined} className="img-responsive" alt={data?.section6_heading} />
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                        <div className="facilities-content">
                            <div className="wow animate__animated animate__slideInRight" data-wow-delay="0.1s" data-wow-duration="1.2s" >
                                <h3 className="heading">{data?.section6_heading}</h3>
                                <span className="gradient-color">{data?.section6_red_heading} </span>
                                <div dangerouslySetInnerHTML={{ __html: data?.section6_description }} />
                                <div className="ensures-btn">
                                    <Link to={"/contact"} className="default-btn" >
                                        <span>Design Your Hotel Solution</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}



